export default "__VITE_ASSET__38e79ccd__"